import { useEffect, useState } from 'react';
import { useCurrentModule } from '../components';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
import { useEclipsePlanRecommendation } from './useEclipsePlanRecommendation';
const ANALYZING_MIN_MS = 1500;
const ANALYZING_MIN_WITHOUT_GENERATED_MS = 2500;
const ANALYZING_MAX_MS = 12000;
const DECIDING_MS = 1200;
export const useAiRevealController = () => {
  const module = useCurrentModule();
  const {
    isEnabled,
    showsGeneratedContent
  } = useAiRecommendationEnabled();
  const {
    isBulletsLoading
  } = useEclipsePlanRecommendation();
  const isDeciding = module.SDK.aiRecommendationStore.useIsDeciding();
  const isRevealed = module.SDK.aiRecommendationStore.useIsRevealed();
  const plansRendered = module.SDK.aiRecommendationStore.useArePlansRendered();
  const recommendedProductId = module.SDK.aiRecommendationStore.useRecommendedProductId();
  const [floorReached, setFloorReached] = useState(false);
  const analyzingMinMs = showsGeneratedContent ? ANALYZING_MIN_MS : ANALYZING_MIN_WITHOUT_GENERATED_MS;
  const isWaitingForRecommendation = showsGeneratedContent ? isBulletsLoading : !recommendedProductId;
  useEffect(() => {
    if (!isEnabled || isDeciding || isRevealed || !plansRendered) {
      return undefined;
    }
    const floor = setTimeout(() => setFloorReached(true), analyzingMinMs);
    const ceiling = setTimeout(() => module.SDK.aiRecommendationStore.decide(), ANALYZING_MAX_MS);
    return () => {
      clearTimeout(floor);
      clearTimeout(ceiling);
    };
  }, [isEnabled, isDeciding, isRevealed, plansRendered, analyzingMinMs, module]);
  useEffect(() => {
    if (isEnabled && plansRendered && floorReached && !isWaitingForRecommendation && !isDeciding && !isRevealed) {
      module.SDK.aiRecommendationStore.decide();
    }
  }, [isEnabled, plansRendered, floorReached, isWaitingForRecommendation, isDeciding, isRevealed, module]);
  useEffect(() => {
    if (!isDeciding || isRevealed) {
      return undefined;
    }
    const timer = setTimeout(() => module.SDK.aiRecommendationStore.reveal(), DECIDING_MS);
    return () => clearTimeout(timer);
  }, [isDeciding, isRevealed, module]);
};
//# sourceMappingURL=useAiRevealController.js.map